import { GetBrandApiArg, GetBrandApiResponse } from '@/services/brands/types';
import { Brand } from '@/types';

import { api } from '../api';

export const brandsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /** Get park list for given brand. */
    getBrand: builder.query<GetBrandApiResponse, GetBrandApiArg>({
      query: (id: Brand) => `/brands/${id}`,
    }),
  }),
});

export const { useGetBrandQuery } = brandsApi;
